import { themeColor, themeBoxShadow } from '@config/theme';
import { LayoutConfig } from './types';

// Layout configuration values
export const layoutConfig: LayoutConfig = {
	drawerWidth: 300,
	mobileBreakpoint: 768,
	tabletBreakpoint: 992,
	largeScreenBreakpoint: 1200,
};

// Style configurations
export const backdropStyle = {
	color: '#fff',
	zIndex: (theme: any) => theme.zIndex.drawer + 1,
	display: 'flex',
	flexDirection: 'column',
	gap: 2,
};

export const mobileFooterStyles = {
	paper: {
		position: 'fixed',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 1000,
		transition: 'all 0.3s ease-in-out',
		height: '66px',
		// iOS-specific fixes
		WebkitTapHighlightColor: 'transparent',
		WebkitTouchCallout: 'none',
		WebkitUserSelect: 'none',
		userSelect: 'none',
	},
	navigation: {
		padding: '5px 30px',
		height: '66px',
		'@media (max-width: 430px)': {
			padding: '5px 10px',
		},
		// iOS-specific fixes
		WebkitTapHighlightColor: 'transparent',
		WebkitTouchCallout: 'none',
		WebkitUserSelect: 'none',
		userSelect: 'none',
	},
	action: {
		default: {
			color: '#7B809A',
			padding: '5px 10px',
			'@media (max-width: 430px)': {
				padding: '5px 0',
				minWidth: '68px',
			},
			fontSize: '12px',
			fontWeight: 500,
			'& .MuiBottomNavigationAction-label': { 
				fontSize: '12px !important',
				WebkitTapHighlightColor: 'transparent',
			},
			'& .MuiSvgIcon-root': { 
				marginBottom: '5px',
				WebkitTapHighlightColor: 'transparent',
			},
			// iOS-specific fixes
			cursor: 'pointer',
			WebkitTapHighlightColor: 'transparent',
			WebkitTouchCallout: 'none',
			WebkitUserSelect: 'none',
			userSelect: 'none',
			// Ensure proper touch target size for iOS
			minHeight: '44px',
			minWidth: '44px',
		},
		active: {
			borderRadius: '15px',
			backgroundColor: themeColor.veryLightGray,
			color: '#1A1A1A',
			padding: '5px 10px',
			'& .MuiSvgIcon-root': { 
				color: themeColor.teal, 
				marginBottom: '5px',
				WebkitTapHighlightColor: 'transparent',
			},
			// iOS-specific fixes
			cursor: 'pointer',
			WebkitTapHighlightColor: 'transparent',
			WebkitTouchCallout: 'none',
			WebkitUserSelect: 'none',
			userSelect: 'none',
			// Ensure proper touch target size for iOS
			minHeight: '44px',
			minWidth: '44px',
		},
		middle: {
			color: '#7B809A',
			padding: '5px 10px',
			'@media (max-width: 430px)': {
				padding: '5px 0',
				minWidth: '68px',
			},
			fontSize: '12px',
			fontWeight: 500,
			'& .MuiBottomNavigationAction-label': { 
				fontSize: '12px !important',
				WebkitTapHighlightColor: 'transparent',
			},
			'& .MuiSvgIcon-root': { 
				marginBottom: '5px',
				WebkitTapHighlightColor: 'transparent',
			},
			// iOS-specific fixes
			cursor: 'pointer',
			WebkitTapHighlightColor: 'transparent',
			WebkitTouchCallout: 'none',
			WebkitUserSelect: 'none',
			userSelect: 'none',
			// Ensure proper touch target size for iOS
			minHeight: '44px',
			minWidth: '44px',
		},
		middleActive: {
			color: '#7B809A',
			padding: '5px 10px',
			'@media (max-width: 430px)': {
				padding: '5px 0',
				minWidth: '68px',
			},
			fontSize: '12px',
			fontWeight: 500,
			'& .MuiBottomNavigationAction-label': { 
				fontSize: '12px !important',
				WebkitTapHighlightColor: 'transparent',
			},
			'& .MuiSvgIcon-root': { 
				marginBottom: '5px',
				WebkitTapHighlightColor: 'transparent',
			},
			// iOS-specific fixes
			cursor: 'pointer',
			WebkitTapHighlightColor: 'transparent',
			WebkitTouchCallout: 'none',
			WebkitUserSelect: 'none',
			userSelect: 'none',
			// Ensure proper touch target size for iOS
			minHeight: '44px',
			minWidth: '44px',
		},
	},
};
